import {useGetCoupons} from './useGetCoupons';
import {useIsCouponWalletActive} from './useIsCouponWalletActive';

export const useGetCouponsCount = () => {
  const isCouponWalletActive = useIsCouponWalletActive();
  const coupons = useGetCoupons({isDisabled: !isCouponWalletActive}).data;

  if (!coupons || !isCouponWalletActive) {
    return 0;
  }

  return coupons.coupon.length;
};
